module.exports = __webpack_public_path__ + "img/TRASH.7a26614b.svg";